import ClickAndCollectRepository from './ClickAndCollectRepository';

export * from './ClickAndCollectRepository';

export default ClickAndCollectRepository;
